export default "__VITE_ASSET__855e3a13__"